import * as React from "react";
function LgIcon() {
    return React.createElement("path", { d: "M3.65381 18.5V5.5H20.6384V18.5H3.65381ZM5.15378 17H8.81536V6.99998H5.15378V17ZM10.3153 17H13.9769V6.99998H10.3153V17ZM15.4768 17H19.1384V6.99998H15.4768V17Z", fill: "currentColor" });
}
export default LgIcon;
//# sourceMappingURL=Lg.js.map